import { UserRole } from '@avanzu/types';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import {
  Box,
  Chip,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';
import PaperSection from '../../../components/PaperSection';
import getRoleColor from '../../../helpers/getRoleColor';

export const PermissionsTable = () => {
  return (
    <PaperSection title="Permissions & Access">
      <Stack spacing={3}>
        {/* Permissions Table */}
        <Box>
          <Typography variant="body1" gutterBottom sx={{ mb: 2 }}>
            The following table outlines the permissions granted to each team role for Xero
            integration.
          </Typography>
          <Table size="small">
            <TableHead>
              <TableRow>
                <TableCell>Permission</TableCell>
                <TableCell align="center">
                  <Chip label="Owner" size="small" color={getRoleColor(UserRole.OWNER)} />
                </TableCell>
                <TableCell align="center">
                  <Chip label="Finance" size="small" color={getRoleColor(UserRole.ADMIN)} />
                </TableCell>
                <TableCell align="center">
                  <Chip label="Member" size="small" color={getRoleColor(UserRole.MEMBER)} />
                </TableCell>
                <TableCell align="center">
                  <Chip label="Viewer" size="small" color={getRoleColor(UserRole.VIEWER)} />
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              <TableRow>
                <TableCell>Connect Xero</TableCell>
                <TableCell align="center">
                  <CheckCircleIcon color="success" fontSize="small" />
                </TableCell>
                <TableCell align="center">-</TableCell>
                <TableCell align="center">-</TableCell>
                <TableCell align="center">-</TableCell>
              </TableRow>
              <TableRow>
                <TableCell>Manage Plan</TableCell>
                <TableCell align="center">
                  <CheckCircleIcon color="success" fontSize="small" />
                </TableCell>
                <TableCell align="center">-</TableCell>
                <TableCell align="center">-</TableCell>
                <TableCell align="center">-</TableCell>
              </TableRow>
              <TableRow>
                <TableCell>Fetch Data</TableCell>
                <TableCell align="center">
                  <CheckCircleIcon color="success" fontSize="small" />
                </TableCell>
                <TableCell align="center">
                  <CheckCircleIcon color="success" fontSize="small" />
                </TableCell>
                <TableCell align="center">
                  <CheckCircleIcon color="success" fontSize="small" />
                </TableCell>
                <TableCell align="center">-</TableCell>
              </TableRow>
              <TableRow>
                <TableCell>Create Allocations</TableCell>
                <TableCell align="center">
                  <CheckCircleIcon color="success" fontSize="small" />
                </TableCell>
                <TableCell align="center">
                  <CheckCircleIcon color="success" fontSize="small" />
                </TableCell>
                <TableCell align="center">
                  <CheckCircleIcon color="success" fontSize="small" />
                </TableCell>
                <TableCell align="center">-</TableCell>
              </TableRow>
              <TableRow>
                <TableCell>View Salaries</TableCell>
                <TableCell align="center">
                  <CheckCircleIcon color="success" fontSize="small" />
                </TableCell>
                <TableCell align="center">
                  <CheckCircleIcon color="success" fontSize="small" />
                </TableCell>
                <TableCell align="center">-</TableCell>
                <TableCell align="center">
                  <CheckCircleIcon color="success" fontSize="small" />
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell>View Employees</TableCell>
                <TableCell align="center">
                  <CheckCircleIcon color="success" fontSize="small" />
                </TableCell>
                <TableCell align="center">
                  <CheckCircleIcon color="success" fontSize="small" />
                </TableCell>
                <TableCell align="center">
                  <CheckCircleIcon color="success" fontSize="small" />
                </TableCell>
                <TableCell align="center">
                  <CheckCircleIcon color="success" fontSize="small" />
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell>View Transactions</TableCell>
                <TableCell align="center">
                  <CheckCircleIcon color="success" fontSize="small" />
                </TableCell>
                <TableCell align="center">
                  <CheckCircleIcon color="success" fontSize="small" />
                </TableCell>
                <TableCell align="center">
                  <CheckCircleIcon color="success" fontSize="small" />
                </TableCell>
                <TableCell align="center">
                  <CheckCircleIcon color="success" fontSize="small" />
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </Box>
      </Stack>
    </PaperSection>
  );
};
